import {
  SET_DOWNLOADED_PDF_USERS,
} from '../actions/downloadedPdfUsers';

let initialState = {
  downloadedPdfUsersData: [],
};

const downloadedPdfUsers = (state = initialState, action) => {
  switch (action.type) {
    case SET_DOWNLOADED_PDF_USERS:
      return {
        ...state,
        downloadedPdfUsersData: action.payload,
      };

    default:
      return state;
  }
};

export default downloadedPdfUsers;
